import classNames from 'classnames'
import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Card } from './Card'

import styles from './Cards.module.scss'
import Progress from '../Progress'
import ProgressPopover from '../ProgressPopover'

interface CardsProps {
  title: React.ReactNode
  total: number
  finish: number
  inProgress: number
  pending: number
  className?: string
}

export const Cards: React.FC<CardsProps> = ({
  title,
  total,
  finish,
  inProgress,
  pending,
  className,
}) => {
  return (
    <Row
      className={classNames(
        styles.cards,
        className,
        'align-content-center mx-0'
      )}
    >
      <Card cardClassName={classNames(styles.areas, styles.cardTotal)}>
        <div className={styles.content}>{title}</div>
        <div className={styles.total}>{total}</div>
      </Card>
      <ProgressPopover
        id={'cards-courses'}
        progress={{
          finish,
          inProgress,
          pending,
        }}
        component={Col}
        className="align-items-center d-flex"
      >
        <Progress finish={finish} inProgress={inProgress} pending={pending} />
      </ProgressPopover>
    </Row>
  )
}

export default Cards
